<template>
  <a-dialog
    v-model="showSignerDialog"
    width="800px"
    max-width="80vw"
    persistent
    scrollable
  >
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <span>{{ bannerHeading }}</span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
     <add-signer-step v-if="processStep === 2" :attendeesList="attendeesList" :signerList.sync="selectSignerList" @nextStep="onSignerNext" @back="onBack" @close="close"></add-signer-step>
     <add-observer-step v-if="processStep === 3" :attendeesList="attendeesList" :selectedSigner="selectSignerList" :signerList.sync="selectObserverList" @nextStep="onObserverNext" @back="backStep" @close="close"></add-observer-step>
    </v-card>
    <confirm-dialog ref="confirmDelete" />
    <Loader :loading="isLoaderloading" :message="loaderText"></Loader>
  </a-dialog>
</template>

<script>
import { mapActions } from "vuex";
import ConfirmDialog from "../../ConfirmDialog.vue";
import Loader from "../../Loader.vue";
import MessageSheet from "../../MessageSheet.vue";
import SignerAction from "./SignerAction.vue";
import SignerOptions from "./SignerOptions.vue";
import AddSignerDialog from "./AddSignerDialog.vue";
import AddObserverStep from "./AddObserverStep.vue";
import AddSignerStep from "./AddSignerStep.vue";
export default {
  components: {
    SignerAction,
    SignerOptions,
    ConfirmDialog,
    MessageSheet,
    Loader,
    AddSignerDialog,
    AddSignerStep,
    AddObserverStep
  },
  name: "AddSignerDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    meetingId: String,
    meetingName: String,
    attendeesList: Array,
    files: { type: Array, default: () => [] },
  },
  data() {
    return {
      isLoaderloading: false,
      selectSignerList: [],
      selectObserverList: [],
      pdfFile: this.files[0],
      signLanguage: "ja",
      processStep: 2,
    };
  },
  computed: {
    loaderText() {
      return this.$t("LoaderText");
    },
    showSignerDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    bannerHeading(){
      return this.processStep === 2 ? this.$t("agenda.lblSelectAttendeeSigner") : this.$t("agenda.lblSelectObserver");
    },
    signerList() {
      return this.selectSignerList.map((obj) => ({
        ...obj,
        signLanguage: obj.signLanguage || "ja",
      }));
    },
    observerList() {
      return this.selectObserverList.map((obj) => ({
        ...obj,
        signLanguage: obj.signLanguage || "ja",
      }));
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    signOptions() {
      return [
        {
          value: "required",
          text: this.$t("agenda.lblSigner"),
        },
        {
          value: "not-required",
          text: this.$t("agenda.lblSignNotRequired"),
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      sendMOMSignatureDocumentEmail: "agenda/sendMOMSignatureDocumentEmail",
    }),
    close,
    onSignerNext,
    backStep,
    onObserverNext,
    onBack,
    createPersonalisedData(email) {
      const user = this.selectSignerList.find((u) => u.email === email);
      const username = user
        ? user.firstName && user.lastName
          ? `${user.firstName} ${user.lastName}`
          : user.name || email
        : email;
        
      return {
        targetId: this.meetingId,
        emailDearRecipient: this.$t("email.emailDearRecipient", {
          username: username,
        }),
        username,
        tenantName: this.tenantName,
        template_id: process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID,
        subject: this.$t("email.signerSubject"),
        message: this.$t("email.signerMessage", {
          tenantName: this.tenantName,
          meetingName: this.meetingName,
          AccessCode: "{AccessCode}",
        }),
        emailPreHeader: this.$t("email.emailPreHeader"),
      };
    },
  },
};

async function onSignerNext(selectSignerList) {
  this.processStep++
}
async function backStep() {
  this.processStep--
}

async function onObserverNext(selectObserverList) {
  this.selectObserverList = selectObserverList
  try {
    this.isLoaderloading = true;
    const email_ids = this.selectSignerList.map((obj) => obj.email);
    let toList = [];
    let observerList = [];
    this.selectSignerList.forEach((value) => {
      let name = value.email;
      if (value.firstName && value.lastName) {
        name = `${value.firstName} ${value.lastName}`;
      }
      toList.push([value.email, name]);
    });
    selectObserverList.forEach((value) => {
      let name = value.email;
      if (value.firstName && value.lastName) {
        name = `${value.firstName} ${value.lastName}`;
      }
      observerList.push({email:value.email, name:  name});
    });
    let personalisedData = {};
    personalisedData = email_ids.reduce(
      (a, v) => ({
        ...a,
        [v]: this.createPersonalisedData(v),
      }),
      {}
    );
    const data = {
      meetingid: this.meetingId,
      sgTemplateId: process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID,
      email_ids,
      toList: toList,
      observers: observerList,
      isPersonalised: true,
      personalisedData,
    };
    let formData = new FormData();
    formData.append("attachment", this.pdfFile);
    formData.append("json_data", JSON.stringify(data));
    const response = await this.sendMOMSignatureDocumentEmail(formData);
    this.$emit("send", response.data?.signature_type);
    this.close();
    this.isLoaderloading = false;
  } catch (error) {
    this.isLoaderloading = false;
  }
}

function onBack() {
  this.$emit("back");
  this.close();
}

function close() {
  this.$emit("input", false);
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>